import { Sun, Moon } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

export function ThemeToggle({ isDark, onToggle }) {
    return (
        <Button
            variant="outline"
            size="sm"
            onClick={onToggle}
            className={cn(
                "h-9 w-9 rounded-lg transition-all",
                isDark
                    ? "bg-[hsl(var(--card))] border-[hsl(var(--border))] text-[hsl(var(--gold-primary))] hover:bg-[hsl(var(--sidebar-hover))]"
                    : "bg-white border-[#E8E1D6] text-[#C9A961] hover:bg-[#F5F1EB]"
            )}
            title={isDark ? "Switch to Light Mode" : "Switch to Dark Mode"}
        >
            {isDark ? (
                <Sun className="w-4 h-4" />
            ) : (
                <Moon className="w-4 h-4" />
            )}
        </Button>
    );
}
